
export const TitleType = [
  { icon: "", text: "Inicio", path: "/home" },
];
